import { AxiosResponse } from 'axios';
import { GlobalResponseType, UrlQuery } from '@/features/common/types';
import { PartItem } from '@/features/shipment/types';
import { useAxios } from '@/features/common/helpers/axios';
import { parseError } from '@/features/common/helpers/errorParser';

const { axiosService } = useAxios();

export const getPartsBook = async ({
  offset = 0,
  limit = 20,
  orderBy = 'id',
  orderByDesc = true,
  search = null,
}: UrlQuery = {}): Promise<PartItem[] | null> => {
  try {
    let queryString = `?Offset=${offset}&Limit=${limit}&OrderBy=${orderBy}&OrderByDescending=${orderByDesc}`;
    if (search) {
      queryString += `&search=${encodeURI(search)}`;
    }

    const partsBookRes: AxiosResponse = await axiosService.get(`/account/parts-book${queryString}`);
    return partsBookRes.data ?? [];
  } catch (err) {
    return null;
  }
};

export const createPartsBook = async (
  partsBook: PartItem,
): Promise<{
  item?: PartItem
} & GlobalResponseType> => {
  try {
    const partsBookRes: AxiosResponse = await axiosService.post('/account/parts-book', partsBook);
    return {
      successful: true,
      item: partsBookRes.data,
      redirectUrl: '',
      errorMessage: '',
    };
  } catch (err) {
    return parseError(err); // TODO: add filter with proper message
  }
};

export const updatePartsBookItem = async (
  id: number,
  partsBookItem: PartItem,
): Promise<{
  item?: PartItem
} & GlobalResponseType> => {
  try {
    const partsBookRes: AxiosResponse = await axiosService.put(`/account/parts-book/${id}`, partsBookItem);
    return {
      successful: true,
      item: partsBookRes.data,
      redirectUrl: '',
      errorMessage: '',
    };
  } catch (err) {
    return parseError(err);
  }
};

export const deletePartsBookItem = async (id: number): Promise<boolean> => {
  try {
    await axiosService.delete(`/account/parts-book/${id}`);
    return true;
  } catch (err) {
    return false;
  }
};
